import 'dayjs/locale/lv'

const lv = {
  calendar: {
    sameDay: '[Šodien pulksten] LT',
    nextDay: '[Rīt pulksten] LT',
    nextWeek: 'dddd [pulksten] LT',
    lastDay: '[Vakar pulksten] LT',
    lastWeek: '[Pagājušā] dddd [pulksten] LT',
    sameElse: 'L'
  }
}

export default lv
